import React, { useCallback, useMemo, useState } from 'react';
import { GroupedContainer } from '../../../../ContratosCreation/components/GroupedContainer';
import { Box, Grid, IconButton } from '@mui/material';
import { CustomButton } from '../../../../../components/customButton/CustomButton';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import { RenderInputByTypeMobile } from '../../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { adaptProductosArray, GET_INSUMOS_LITE } from '../../../../../data/graphQL/queries/Reclamos/getAllProductosLite';
import Searcher from './searchFields/Searcher';
import moment from 'moment';

const TIPO_INSUMO_TEC_MED = 3;

const GrillaProductosField = ({
    title = '',
    noRowsLabel,
    onChange,
    entityName,
    value = [],
    disabled
}) => {

    const columns = [
        {
            field: 'action',
            headerName: '',
            align: 'center',
            renderCell: ({ row }) => {
                return (
                    <IconButton disabled={disabled} onClick={() => onDeleteRow(row.id)}>
                        <DeleteOutlinedIcon color={disabled ? 'disabled' : 'action'} />
                    </IconButton>
                )
            }
        },
        {
            field: 'nombre',
            headerName: 'Nombre',
            flex: 2
        },
        {
            field: 'lote',
            headerName: 'Lote',
            flex: 2,
        },
        {
            field: 'fechaVencimiento',
            headerName: 'F. Vencimiento',
            type: 'date',
            flex: 2,
        },
        {
            field: 'numeroRemito',
            headerName: 'Nro Remito',
            flex: 2,
        },
        {
            field: 'cantidad',
            headerName: 'Cantidad',
            type: 'int',
            flex: 2,
        }
    ];

    const productColumns = [
        {
            field: 'idInsumo',
            headerName: 'Cod. Producto',
            flex: 4
        },
        {
            field: 'descripcion',
            headerName: 'Nombre',
            headerAlign: 'left',
            align: 'left',
            flex: 8
        },
    ];

    const [openModal, setOpenModal] = useState(false);
    const [newProductData, setNewProductData] = useState({});

    const isTecnologiaMedica = useMemo(() => (entityName === 'tecnologiasMedicas'), [entityName]);
    const CONFIGURATED_COLUMNS = useMemo(() => (generateColumnsDefaultConfiguration(columns)), [columns, disabled]);
    const PRODUCT_COLUMNS = useMemo(() => (generateColumnsDefaultConfiguration(productColumns)), [productColumns]);

    const createDisabled = useMemo(() => (
        !newProductData.idInsumo
        || !newProductData.lote?.trim()
        || !newProductData.fechaVencimiento
    ), [newProductData]);

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => {
        setOpenModal(false);
        resetProduct();
    }

    const onDeleteRow = (rowId) => {
        const rowIndex = rowId - 1;

        const filteredValue = value.filter((row, index) => index !== rowIndex);
        onChange(entityName, filteredValue)
    }

    const onCreate = () => {
        onChange(entityName, [...value, newProductData]);
        handleCloseModal();
    }

    const resetProduct = () => setNewProductData({});

    const handleChangeProduct = (fieldName, value) => {
        setNewProductData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    }

    const getSearchParams = useCallback((textValue) => {
        const filterTipoInsumo = {
            idTipoInsumo: { [isTecnologiaMedica ? 'eq' : 'neq']: TIPO_INSUMO_TEC_MED }
        };

        const searchParams = {
            and: [filterTipoInsumo]
        };

        if (textValue) {
            searchParams.and.push({
                or: [
                    { descripcion: { contains: textValue } },
                    { idInsumo: { contains: textValue } }
                ]
            });
        }

        return searchParams;
    }, [isTecnologiaMedica]);

    const getEntityValue = (row) => {
        const value = !!row ? `${row.idInsumo} - ${row.descripcion}` : null;

        return value;
    }

    return (
        <>
 <Grid container rowSpacing={1} size={{ xs: 100 }}>
 <Grid size={{ xs: 12 }}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <h3 style={{ margin: 0 }}>{title}</h3>
                        <CustomButton
                            label='Agregar producto'
                            variant='outlined'
                            onClick={handleOpenModal}
                            disabled={disabled}
                        />
                    </Box>
                </Grid>
 <Grid size={{ xs: 12 }}>
                    <DataGridGenerico
                        rows={value}
                        columns={CONFIGURATED_COLUMNS}
                        hideFooterPagination={false}
                        toolbar={false}
                        localeText={{ noRowsLabel }}
                    />
                </Grid>
            </Grid>
            <CustomDialog
                maxWidth='md'
                fullWidth
                onCancel={handleCloseModal}
                open={openModal}
                cancelText='Cerrar'
                title='Agregar producto'
                onAccept={onCreate}
                acceptText='Agregar'
                acceptDisabled={createDisabled}
            >
                <Grid container spacing={2}>
 <Grid size={{ xs: 12, md: 6 }}>
                        <Searcher
                            displayName='Producto'
                            titleModal='Seleccionar productos'
                            entityName='allinsumos'
                            entityId='idInsumo'
                            entityIdValue={undefined}
                            columns={PRODUCT_COLUMNS}
                            query={GET_INSUMOS_LITE}
                            adapter={adaptProductosArray}
                            getSearchParams={getSearchParams}
                            onRowClick={(value) => {
                                handleChangeProduct('idInsumo', value.idInsumoN);
                                handleChangeProduct('nombre', value.descripcion);
                            }}
                            getEntityValue={getEntityValue}
                        />
                    </Grid>
 <Grid container spacing={2} size={{ xs: 12 }}>
                        {inputs.map((input, index) => (
 <Grid key={input.name + index} size={{ xs: 3 }}>
                                <RenderInputByTypeMobile
                                    input={input}
                                    handleChange={handleChangeProduct}
                                    value={newProductData[input.name]}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </CustomDialog>
        </>
    )
}

const inputs = [
    {
        name: 'lote',
        displayName: 'Lote',
        type: 'string',
    },
    {
        name: 'fechaVencimiento',
        displayName: 'F. Vencimiento',
        type: 'date',

    },
    {
        name: 'numeroRemito',
        displayName: 'N. remito',
        type: 'string',
    },
    {
        name: 'cantidad',
        displayName: 'Cantidad',
        disableFuture: true,
        type: 'int',

    },
]

export default GrillaProductosField;